<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.veiculo"
        ref="RkmDataTable"
        sort-by="descricaoModelo"
        search-by="descricaoModelo"
    >

        <template v-slot:cell(numeroPlaca)="row">
            {{ row.value | formatPlaca }}
        </template>

        <template v-slot:cell(actions)="{ item }">
            <template v-if="!$scopedSlots.actions">
                <rkm-button
                    @click="handleEdit(item.id)"
                    color="primary"
                    small
                    title="Editar"
                    autorize="edit-transporte-paciente-veiculo"
                >
                    <rkm-icon icon="pen"/>
                </rkm-button>

                <rkm-button
                    v-if="!item.bloqueado"
                    @click="handleBlock(item.id, false)"
                    color="dark"
                    small
                    title="Inativar"
                    autorize="update-transporte-paciente-veiculo"
                >
                    <rkm-icon icon="ban"/>
                </rkm-button>

                <rkm-button
                    v-else
                    @click="handleBlock(item.id, true)"
                    color="success"
                    small
                    title="Ativar"
                    autorize="update-transporte-paciente-veiculo"
                >
                    <rkm-icon icon="check-circle"/>
                </rkm-button>

                <rkm-button
                    @click="handleDestroy(item.id)"
                    color="danger"
                    small
                    title="Excluir"
                    autorize="destroy-transporte-paciente-veiculo"
                >
                    <rkm-icon icon="trash"/>
                </rkm-button>

                <slot
                    name="actions"
                    :veiculo="item"
                />
            </template>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { error, repository, stringCase} from '@/mixins';

// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'numeroPlaca',
                    label: 'Placa',
                    name: 'transportePacienteVeiculo.numeroPlaca',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'prefixo',
                    label: 'Prefixo',
                    name: 'transportePacienteVeiculo.prefixo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoModelo',
                    label: 'Modelo',
                    name: 'transportePacienteVeiculo.descricaoModelo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoMarca',
                    label: 'Marca',
                    name: 'transportePacienteVeiculoMarca.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoTipo',
                    label: 'Tipo',
                    name: 'transportePacienteVeiculoTipo.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'anoFabricacao',
                    label: 'Ano',
                    name: 'transportePacienteVeiculo.anoFabricacao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'descricaoCor',
                    label: 'Cor predominante',
                    name: 'transportePacienteVeiculoCor.descricao',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'numeroPatrimonio',
                    label: 'Patrimônio',
                    name: 'transportePacienteVeiculo.numeroPatrimonio',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'status',
                    label: 'Status',
                    name: 'transportePacienteVeiculo.bloqueado',
                    searchable: true,
                    sortable: true
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                }
            ];
        }
    },
    created() {
        this.repositories = {
            veiculo: this.getConectaSusRepository('transportePaciente.veiculo')
        }
    },
    filters: {
        formatPlaca: formats.numeroPlaca,
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'transporte-paciente-veiculo-edit', params: { id: id } })
        },
        handleBlock(id, ativar) {
            const bloqueio = () => this.repositories.veiculo.bloquear(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showConfirmation(
                `Deseja realmente ${ativar ? 'ativar' : 'inativar'} o veículo?`,
                bloqueio,
                null,
                this.handleError
            )
        },
        handleDestroy(id) {
            const exclusao = () => this.repositories.veiculo.destroy(id)
                .then(() => this.$refs.RkmDataTable.refresh())

            this.showDeleteConfirmation(
                'Deseja realmente excluir o veículo?',
                exclusao,
                this.handleError
            )
        },
    },
    mixins: [ error, repository, stringCase ],
};

</script>